import { observer } from 'mobx-react-lite'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { MoreMenu } from './MoreMenu'

export interface MoreMenuContainerProps {
  vm: JobManagementViewModel
}

export const MoreMenuContainer = observer(function MoreMenuContainer({
  vm,
}: MoreMenuContainerProps) {
  return (
    <MoreMenu
      canNotifyPros={vm.canNotifyProsOfUnclaimedJobs}
      onNotifyPros={vm.notifyProsOfUnclaimedJobsVm.modal.show}
      selectedCount={vm.selectionVm.selectedJobs.size}
      archiveRestoreAction={vm.selectionVm.permittedArchiveRestoreAction}
      onArchiveRestore={vm.selectionVm.archiveRestoreJobs}
      canClone={vm.selectionVm.canCloneJobs}
      onClone={vm.selectionVm.cloneJobs}
      canTransfer={vm.selectionVm.canTransferJobs}
      onTransfer={vm.selectionVm.transferJobs}
      canAdvance={vm.selectionVm.canAdvanceJobs}
      onAdvance={vm.selectionVm.advanceJobsVm.show}
    />
  )
})
